<template>
  <div>
    <leftnav class="fl" v-title :data-title="title"></leftnav>
    <div
      class="index_left"
      :style="isCollapse ? 'margin-left: 0;width:100%' : ''"
    >
      <govheader></govheader>
      <div class="heightVh95 whitebox container-flex-center">
        <freeUserTips :type="4" :bgtype="0"></freeUserTips>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  data() {
    return {
      title: "",
    };
  },
  computed: {
    ...mapState({
      // isCollapse: (state) => state.app.isCollapse,
      isCollapse: (state) => state.isCollapse,
    }),
    ...mapGetters(["isCollapse"]),
  },
  created() {
    this.title = this.$route.query.title;
  },
  watch: {
    $route(to, from) {
      this.title = to.query.title;
      this.restPage();
    },
  },
  mounted() {
    this.restPage();
  },
  methods: {
    restPage() {
      this.bus.$emit("loading", true);
      setTimeout(() => {
        this.bus.$emit("loading", false);
      }, 1000);
    },
  },
};
</script>

<style></style>